import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { logout, accessTokenStorage } from '../services/auth';
import { GET_ALL_NOTIFICATIONS } from '../graphql/GET_ALL_NOTIFICATIONS';

const initState = {
  isLoading: false,
  notifications: []
};

export const useNotification = () => {
  const [notificationsData, setNotificationsData] = useState<object[]>(
    initState.notifications
  );
  const hasToken = !!accessTokenStorage.get();
  const { loading, error, data } = useQuery(GET_ALL_NOTIFICATIONS, {
    errorPolicy: 'none',
    skip: !hasToken
  });

  useEffect(() => {
    if (data) {
      setNotificationsData(data.getAllNotifications);
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      const isBlockedError =
        error?.graphQLErrors?.some((e: any) =>
          e.message?.toLowerCase().includes('blocked')
        ) || error?.message?.toLowerCase().includes('blocked');

      if (isBlockedError) {
        logout('Your account has been blocked. Please contact the administrator.');
      }
    }
  }, [error]);

  return {
    error,
    isLoading: loading,
    notifications: notificationsData
  };
};
